var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMais({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2455 5106 c-83 -20 -146 -56 -211 -120 -65 -66 -105 -137 -123 -224 -8 -37 -11 -316 -11 -902 l0 -850 -850 0 c-586 0 -865 -3 -902 -11 -86 -18 -158 -58 -224 -123 -177 -178 -177 -455 0 -631 66 -65 138 -105 224 -124 37 -8 307 -11 902 -11 l850 0 0 -850 c0 -586 3 -865 11 -902 18 -87 58 -158 123 -223 179 -178 455 -178 631 -1 65 66 105 138 124 224 8 37 11 307 11 902 l0 850 850 0 c586 0 865 3 902 11 87 18 158 58 223 123 178 179 178 454 1 632 -66 66 -144 108 -227 124 -31 6 -390 10 -900 10 l-849 0 0 850 c0 586 -3 865 -11 902 -18 86 -58 158 -123 224 -114 114 -267 158 -421 120z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMais);
export default __webpack_public_path__ + "static/media/mais.d70fe933004633fa0f223b68d6346f4d.svg";
export { ForwardRef as ReactComponent };